import {
  InputMaybe,
  PopupVideoInput,
  PopupVideoSourceKind,
} from "~/src/__generated__/schema";

export const POPUP_VIDEO_MAX_SIZE_MB = 100;
export const POPUP_VIDEO_MAX_BYTES = POPUP_VIDEO_MAX_SIZE_MB * 1024 * 1024;
export const POPUP_VIDEO_PREVIEW_MAX_WIDTH = "300px";

export const uploadedVideoPreviewStyle = {
  width: "100%",
  maxWidth: POPUP_VIDEO_PREVIEW_MAX_WIDTH,
  aspectRatio: "16 / 9",
  marginTop: "8px",
};

export type PopupVideoFormValues = PopupVideoInput & {
  videoFileUrl?: string | null;
  playbackUrl?: string | null;
  videoFile?: File | null;
};

export const defaultPopupVideoFormValues = (): PopupVideoFormValues => ({
  videoSource: "YOUTUBE" as PopupVideoSourceKind,
  screenType: "NORMAL",
});

export const hasPopupVideoContent = (
  popupVideo: PopupVideoFormValues | null | undefined
): boolean => {
  if (!popupVideo) return false;

  if (popupVideo.videoSource === "YOUTUBE") {
    return !!popupVideo.video?.trim();
  }

  if (popupVideo.videoSource === "UPLOADED") {
    return (
      popupVideo.videoFile instanceof File ||
      !!popupVideo.playbackUrl ||
      !!popupVideo.videoFileUrl
    );
  }

  return false;
};

export const clearUploadedVideoFields = (
  setFieldValue: (field: string, value: unknown) => void
): void => {
  setFieldValue("popupVideo.videoFile", null);
  setFieldValue("popupVideo.videoFileUrl", null);
  setFieldValue("popupVideo.playbackUrl", null);
};

export const appendPopupVideoUploadable = (
  popupVideo: PopupVideoFormValues | null | undefined,
  uploadables: Record<string, File>,
  path = "variables.input.popupVideo.videoFile"
): void => {
  const file = popupVideo?.videoFile;
  if (file instanceof File) {
    uploadables[path] = file;
  }
};

export const serializePopupVideoForMutation = (
  popupVideo: PopupVideoFormValues | null | undefined
): InputMaybe<PopupVideoInput> | undefined => {
  if (!popupVideo) return popupVideo;

  const { videoFileUrl, playbackUrl, videoFile, ...rest } = popupVideo;

  if (rest.videoSource === "YOUTUBE") {
    return {
      ...rest,
      videoFile: undefined,
    };
  }

  if (rest.videoSource === "UPLOADED") {
    return {
      ...rest,
      video: undefined,
      videoFile: videoFile instanceof File ? videoFile : undefined,
    };
  }

  return rest;
};
